import { PayoutInvoiceType } from '~/models/PayoutModel';
export const payoutStatusTextsPath = 'payouts.payoutStatusLabels';
export const payoutInvoiceTypeTextsPath = 'pages.payoutsDashboard.columns.types';
export function getPayoutInvoiceTypeLabel(type, texts) {
    switch(type){
        case PayoutInvoiceType.Payment:
            return texts.payment();
        case PayoutInvoiceType.Refund:
            return texts.refund();
        case PayoutInvoiceType.Dispute:
            return texts.dispute();
        case PayoutInvoiceType.DisputeWon:
            return texts.disputeWon();
        case PayoutInvoiceType.LateReturn:
            return texts.lateReturn();
    }
}
export function getStatusText(payout, texts) {
    return payout.isPaid() ? payout.amount().isNegative() ? texts.withdrawn() : texts.deposited() : texts.failed();
}
export function getStatusBadgeSkin(payout) {
    if (!payout.isPaid()) return 'error';
    return payout.amount().isNegative() ? 'default' : 'success';
}
